import { ShowCargaExcelModalForm } from "./ShowCargaExcelModalForm"


const ShowCargaExcelModalFormWrapper = () => {
    return (<ShowCargaExcelModalForm />)
}

export {ShowCargaExcelModalFormWrapper}